const
    Search = require('./components/Search'),
    $      = jQuery;

export function initCommonScripts() {
    let
        ua  = navigator.userAgent,
        nav = '';

    if (ua.match(/iPhone|iPad/i)) {
        nav = 'iChaos';
    } else if (ua.match(/Android/i)) {
        nav = 'androidDevice';
    }

    let regionPickerButtons = [].slice.call(document.querySelectorAll('.regionPickerButton'));
    regionPickerButtons.forEach((button) => {
        button.addEventListener('click', () => {
            $(document.body).trigger('regionPicker/show');
        });
    });

    $(document.body).addClass(nav);


    $('.email-link[data-link]').each((i, link) => {
        let email = $(link).data('link')
            .split('').map(ch => {
                switch (ch) {
                    case '@':
                        return '.';
                    case '.':
                        return '@';
                    default:
                        return ch;
                }
            }).reverse().slice(5, -4).join('');
        if (nav === 'iChaos') {
            $(link).on('click', () => {
                let nw = window.open(`mailto:${email}`);
                setTimeout(() => nw.close(), 500);
            });
        } else {
            let iframe = $(`<iframe src="mailto:${email}" width="1" height="1"></iframe>`);
            $(link).on('click', () => {
                $(document.body).append(iframe);
                setTimeout(() => iframe.detach(), 500);
            });
        }
    });

    if ($(document.body).hasClass('search')) {
        let
            searchCont = $('.search-container'),
            search     = searchCont.length ? new Search(searchCont, true, 10) : null;
        if (search) {
            search.input.trigger('focus');
        }
    }


    if ($(document.body).hasClass('error404')) {
        let
            searchCont = $('.search-container'),
            search     = searchCont.length ? new Search(searchCont) : null;
        if (search) {
            search.input.trigger('focus');
        }

        let
            reportButton = $('.notFound-option.v-report'),
            reportSent   = false;

        const
            onReportFail    = () => {
                reportButton.removeClass('s-sending');
                reportButton.after(`<span class="report-failed">${reportButton.data('error-text') || 'Failed to send report'}</span>`);
            },
            onReportSuccess = () => {
                reportButton.removeClass('s-sending').addClass('s-sent');
                reportButton.after(`<span class="report-success">${reportButton.data('success-text') || 'Report sent'}</span>`);
                reportSent = true;
            };

        reportButton.on('click', event => {
            event.preventDefault();
            if (reportSent) {
                return;
            }
            reportButton.siblings('.report-failed').remove();
            reportButton.addClass('s-sending');
            $.ajax({
                url: RES.global('ajaxurl'),
                method: 'POST',
                data: {
                    action: 'WA_WP_CommonHandler',
                    method: 'reportBrokenURL',
                    url: location.href,
                },
            }).done(data => {
                if (data && data.success && data.payload) {
                    onReportSuccess();
                } else {
                    onReportFail();
                }
            }).fail((jqXHR, message, code) => {
                onReportFail();
            });
        });
    }


    {
        // Home slider
        const $el = $('.homeSlider-slides');
        const args = {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            prevArrow: $('.icon-arrows-left'),
            nextArrow: $('.icon-arrows-right'),
        };
        if ($el.data('autoplay')) {
            args.autoplay = true;
            args.autoplaySpeed = parseInt($el.data('autoplay-speed')) || 5000;
        }
        $el.slick(args);
    }


    {
        //Product page tabs
        $('.sProduct-sectionNav-button').each(function(i, item) {
            let
                $item     = $(item),
                $link     = $item.attr('data-section'),
                $sections = $('.sProduct-sections'),
                $tab      = $('.sProduct-section'),
                $buttons  = $('.sProduct-sectionNav-button');

            $item.on('click', () => {
                $buttons.removeClass('activeTab');
                $tab.removeClass('activeSection');
                $sections.find('[data-section=' + $link + ']').addClass('activeSection');
                $item.addClass('activeTab');
            });

        });

        $('.sProduct-mbTab-button').each(function(i, item) {
            let
                $item     = $(item),
                link      = $item.data('section'),
                tabs      = $('.sProduct-mbTab-button'),
                section   = $('.sProduct-section'),
                activeSec = $('.sProduct-sections').find('[data-section=' + link + ']');

            $item.on('click', () => {

                if ($item.hasClass('activeTab')) {
                    activeSec.removeClass('activeSection');
                    $item.removeClass('activeTab');
                } else {
                    tabs.removeClass('activeTab');
                    section.removeClass('activeSection');
                    activeSec.addClass('activeSection');
                    $item.addClass('activeTab');
                }
            });
        });
    }

    {
        // Product image gallery
        $('.sProduct-specs-thumbnails-button').each(function(i, item) {
            let
                $item       = $(item),
                $imageFull  = $item.data('image-full'),
                $imageMain  = $('.mainImage'),
                $buttonMain = $('.sProduct-specs-image-button'),
                $image      = $item.find('img');


            $item.on('click', () => {
                $('.sProduct-specs-thumbnails-button').find('img').removeClass('currentThum');
                $image.addClass('currentThum');
                $imageMain.attr('src', $imageFull);
                $buttonMain.attr('href', $imageFull);
            });

        });
    }


    {
        //Product specifications gallery
        $('#specsGallery').lightGallery({
            counter: false,
            share: false,
            getCaptionFromTitleOrAlt: false,
        });
    }


    {
        // Mobile selector tabs
        $('.mobileSelect').each(function() {
            let
                list  = $(this).find('.mobileSelect-list'),
                title = list.find('.activeTab').data('title');

            $(this).on('click', () => {
                list.slideToggle();
            });
            $(this).find('span').text(title);
        });


        //Modal for images
        $('.download-button').each(function() {
            let
                $item    = $(this),
                modal    = $item.siblings('.download-modal'),
                closeBtn = modal.find('.modal-close'),
                downlBtn = modal.find('.downloadButton'),
                label    = modal.find('.download-modal-label'),
                checkbox = modal.find('.download-modal-checkbox');

            $item.on('click', () => {
                modal.fadeIn();

                label.on('click', () => {
                    if (checkbox.is(':checked')) {
                        downlBtn.removeClass('downloadButton--disabled');
                    } else {
                        downlBtn.addClass('downloadButton--disabled');
                    }
                });

                closeBtn.on('click', () => {
                    modal.fadeOut();
                });

            });
        });
    }

    {
        //Pop-ups and CTA
        let
            popup     = $('.popup'),
            confPopup = $('.confirmation');

        function closeCTA(cta) {
            if (window.innerWidth <= 700) {
                cta.animate({
                    bottom: '-1000px',
                });
            } else {
                cta.animate({
                    right: '-2000px',
                });
            }
        }

        function openCTA(cta) {
            if (window.innerWidth <= 700) {
                cta.animate({
                    bottom: null,
                });
            } else {
                cta.animate({
                    right: null,
                });
            }
        }

        if (popup.length) {

            popup.each(function() {
                if (!this.id) {
                    return;
                }
                let
                    id      = this.id,
                    popup   = $(this),
                    openers = $(`[data-popup-button="${id}"]`);

                popup.find('.closeButton').on('click', () => {
                    popup.fadeOut();
                    openCTA($('.cta'));
                });
                popup.find('.wpcf7').on('wpcf7:mailsent', () => {
                    popup.fadeOut();
                    confPopup.fadeIn();
                });
                confPopup.find('.confirmation-closeButton').on('click', () => {
                    confPopup.fadeOut();
                });

                openers.on('click', event => {
                    event.preventDefault();
                    popup.fadeIn();
                    closeCTA($('.cta'));
                });

            });
        }

        //CTA
        $('.cta').each(function() {
            let cta = $(this);

            $(window).on('scroll load resize orientationchange', () => {
                let threshold = document.body.scrollHeight < window.innerHeight * 2
                                ? (document.body.scrollHeight - window.innerHeight) / 2
                                : window.innerHeight / 2;

                threshold = threshold > 0 ? threshold : 0;

                if (window.pageYOffset >= threshold) {
                    cta.addClass('active');
                } else {
                    cta.removeClass('active');
                }
            });

            cta.find('.cta-close').on('click', () => {
                closeCTA(cta);
            });
        });
    }
}

export function initMissingImageSubstitution(replacementUrl) {

    const extractUrlsRe = /["'\s\b]?((?:https?:\/)?\/[^"'\s\b]+)/ig;
    let processingUrls = [];
    const processedUrls = {};

    traverse(document.documentElement);

    const observer = new MutationObserver(async list => {
        for (let mutation of list) {
            if (mutation.type === 'childList') {
                mutation.target instanceof HTMLElement && await traverse(mutation.target);
            }
        }
    });
    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });

    /**
     *
     * @param {HTMLElement} element
     */
    async function traverse(element) {
        for (let child of element.children) {
            child instanceof HTMLElement && await traverse(child);
        }
        await apply(element);
    }

    /**
     *
     * @param {HTMLElement} element
     */
    async function apply(element) {
        if (element.tagName === 'IMG') {
            const [src, srcset] = [element.getAttribute('src'), element.getAttribute('srcset')];
            if (src) {
                element.setAttribute('src', await replaceUrl(src));
            }
            if (srcset) {
                element.setAttribute('srcset', await replaceMultiple(srcset));
            }
        } else if (element.style.backgroundImage) {
            element.style.backgroundImage = await replaceMultiple(element.style.backgroundImage);
        }
    }

    /**
     *
     * @param {string} urls
     * @returns {string}
     */
    async function replaceMultiple(urls) {
        const matches = [...urls.matchAll(extractUrlsRe)];
        let newUrls = urls;
        if (matches.length > 0) {
            for (let match of matches) {
                newUrls = newUrls.replace(match[1], await replaceUrl(match[1]));
            }
        }
        return newUrls;
    }

    /**
     *
     * @param {string} url
     * @returns {string}
     */
    async function replaceUrl(url) {
        if (processedUrls[url]) {
            return processedUrls[url];
        } else if (processingUrls.includes(url)) {
            return new Promise((resolve, reject) => {
                let counter = 0;
                let intval = setInterval(() => {
                    counter++;
                    if (processedUrls[url]) {
                        window.clearInterval(intval);
                        resolve(processedUrls[url]);
                    } else if (counter >= 100) {
                        reject();
                    }
                }, 500);
            });
        }

        processingUrls.push(url);

        const isLocalShortUrl = url.match(/^\/[^\/]+/),
              isLocalLongUrl  = url.indexOf(location.origin) >= 0;

        if (isLocalShortUrl || isLocalLongUrl) {
            const available = await isImageAvailable(url);

            if (available) {
                processedUrls[url] = url;
            } else if (isLocalShortUrl) {
                processedUrls[url] = `${replacementUrl}${url}`;
            } else if (isLocalLongUrl) {
                processedUrls[url] = url.replace(location.origin, replacementUrl);
            }
        } else {
            processedUrls[url] = url;
        }

        if (processedUrls[url] !== url) {
            console.log(`Replacing ${url} -> ${processedUrls[url]}`);
        }

        processingUrls = processingUrls.filter(u => u !== url);

        return processedUrls[url]
    }

    async function isImageAvailable(url) {
        const response = await window.fetch(url)
        return response.status >= 200 && response.status < 400
    }
}
